import loadable from "@loadable/component";
import GeneralTextTransform from "./GeneralText/transform";
import videoTransform from "./Video/transform";
import mentorListTransform from "./MentorList/transform";
import GeneralTextWithImageTransform from "./GeneralTextWithImage/transform";
import UpcomingProgramsTransform from "./UpcomingPrograms/transform";
import ProgramDetailsListTransform from "./university/PogramDetailsList/transform";
import ProgramDetailsCardTransform from "./university/PogramDetailsCard/transform";
import ProgramListTransform from "./ProgramList/transform";
import AccordionTransform from "./Accordion/transform";
import ApplicationFormTransform from "./university/ApplicationForm/transform";
import LeadFormTransform from "./university/LeadForm/transform";
import ContactUsTransform from "./ContactUs/transform";
import CTAButtonTransform from "./CTAButton/transform";
import ThankYouHeaderTransform from "./university/ThankYouHeader/transform";
import BlogListTransform from "./university/Blog/BlogList/transform";
import BlogImageTransform from "./BlogImage/transform";
import BlogCategoriesTransform from "./university/Blog/BlogCategories/transform";
import BlogBreadCrumbsTransform from "./university/Blog/BlogBreadCrumbs/transform";
import BlogContentTransform from "./BlogContent/transform";
import BlogVideoTransform from "./BlogVideo/transform";
import BlogAuthorInfoTransform from "./BlogAuthorInfo/transform";
import BlogImageBannerTransform from "./university/Blog/BlogImageBanner/transform";
import AddressWithLogoTransform from "./AddressWithLogo/transform";
import PoweredByTransform from "./PoweredBy/transform";
import ImageTransform from "./Image/transform";
import LinksListTransform from "./LinksList/transform";
import SocialLinksTransform from "./SocialLinks/transform";
import RichTextTransform from "./RichText/transform";
import ProgramScheduleTransform from "./ProgramSchedule/transform";
import ImageBannerTransform from "./ImageBanner/transform";
import StudentTestimonialTransform from "./StudentTestimonial/transform";
import ProgramListV2Transform from "./ProgramListV2/transform";
import StudentProjectTransform from "./StudentProject/transform";
import HeaderComponentTransfrom from "./HeaderComponent/transform";
import TuitionTransform from "./Tuition/transform";
import UpcomingProgramsWRTransform from "./UpcomingProgramsWR/transform";
import TuitionWRTransform from "./TuitionWR/transform";
import BlogCategoriesWRTransform from "./RebrandBlog/BlogCategoriesWR/transform";
import BlogContentWRTransform from "./RebrandBlog/BlogContentWR/transform";
import BlogBannerWRTransform from "./RebrandBlog/BlogBannerWR/transform";
import LatestPostsTransform from "./RebrandBlog/LatestPosts/transform";
import FeaturedPostsTransform from "./RebrandBlog/FeaturedPosts/transform";
import AutomatedMentorCardsTransform from "./AutomatedMentorCards/transform";

import {
	PortfolioShowcaseTransform,
	CenteredContentTransform,
	CurriculumWRTransform,
	SecondaryNavigationWRTransform,
	PricingWRTransform,
	RedesignFAQTransform,
	MentorCardListTransform,
	SimplifiedListTransform,
	MediaWithTextTransform,
	AlternateSideContentModuleTransform,
	LeadFormWRTransform,
	ApplicationFormWRTransform,
	BoldTextTransform,
	HeroBannerWRTransform,
	AlumniBarTransform,
	FormWrapperTransform,
	BragBarTransform,
	ModalWithFormTransform,
	HypeCardTransform,
	ComparisonTableTransform,
	TestimonialTransform,
	OverlappingCardTransform,
	FeatureCardsTransform,
	PageNotFoundTransform,
	ImportantDateCardTransform,
	ProgramInfoPanelTransform,
	StatsWRTransform,
	ReviewsModuleTransform,
} from "@website-builder/ui/shared/components/transformers";
import {
	PortfolioShowcase,
	CenteredContent,
	CurriculumWR,
	SecondaryNavigationWR,
	PricingWR,
	RedesignFAQ,
	MentorCardList,
	SimplifiedList,
	MediaWithText,
	AlternateSideContentModule,
	LeadFormWR,
	ApplicationFormWR,
	BoldText,
	HeroBannerWR,
	AlumniBar,
	FormWrapper,
	BragBar,
	ModalWithForm,
	HypeCard,
	ComparisonTable,
	Testimonial,
	OverlappingCard,
	FeatureCards,
	PageNotFound,
	ImportantDateCard,
	ProgramInfoPanel,
	StatsWR,
	ReviewsModule,
} from "@website-builder/ui/shared/components";

export const NavigationFooterPaid = loadable(
	() => import("./NavigationFooterPaid"),
);

export const Components = {
	GeneralText: loadable(() => import("./GeneralText")),
	Video: loadable(() => import("./Video")),
	Accordion: loadable(() => import("./Accordion")),
	MentorList: loadable(() => import("./MentorList")),
	GeneralTextWithImage: loadable(() => import("./GeneralTextWithImage")),
	UpcomingPrograms: loadable(() => import("./UpcomingPrograms")),
	ProgramDetailsList: loadable(() => import("./university/PogramDetailsList")),
	ProgramDetailsCard: loadable(() => import("./university/PogramDetailsCard")),
	ContactUs: loadable(() => import("./ContactUs")),
	ProgramList: loadable(() => import("./ProgramList")),
	ApplicationForm: loadable(() => import("./university/ApplicationForm")),
	LeadForm: loadable(() => import("./university/LeadForm")),
	QuickLinksPanel: loadable(() => import("./QuickLinksPanel")),
	ImageBanner: loadable(() => import("./ImageBanner")),
	ThankYouHeader: loadable(() => import("./university/ThankYouHeader")),
	BlogList: loadable(() => import("./university/Blog/BlogList")),
	BlogImage: loadable(() => import("./BlogImage")),
	BlogCategories: loadable(() => import("./university/Blog/BlogCategories")),
	BlogBreadCrumbs: loadable(() => import("./university/Blog/BlogBreadCrumbs")),
	BlogContent: loadable(() => import("./BlogContent")),
	BlogVideo: loadable(() => import("./BlogVideo")),
	BlogAuthorInfo: loadable(() => import("./BlogAuthorInfo")),
	BlogImageBanner: loadable(() => import("./university/Blog/BlogImageBanner")),
	AddressWithLogo: loadable(() => import("./AddressWithLogo")),
	PoweredBy: loadable(() => import("./PoweredBy")),
	Image: loadable(() => import("./Image")),
	LinksList: loadable(() => import("./LinksList")),
	SocialLinks: loadable(() => import("./SocialLinks")),
	RichText: loadable(() => import("./RichText")),
	ProgramSchedule: loadable(() => import("./ProgramSchedule")),
	StudentTestimonial: loadable(() => import("./StudentTestimonial")),
	ProgramListV2: loadable(() => import("./ProgramListV2")),
	StudentProject: loadable(() => import("./StudentProject")),
	HeaderComponent: loadable(() => import("./HeaderComponent")),
	Tuition: loadable(() => import("./Tuition")),
	CTAButton: loadable(() => import("./CTAButton")),
	UserDetails: loadable(() => import("./UserDetails")),
	UpcomingProgramsWR: loadable(() => import("./UpcomingProgramsWR")),
	TuitionWR: loadable(() => import("./TuitionWR")),
	BlogCategoriesWR: loadable(() => import("./RebrandBlog/BlogCategoriesWR")),
	BlogContentWR: loadable(() => import("./RebrandBlog/BlogContentWR")),
	BlogBannerWR: loadable(() => import("./RebrandBlog/BlogBannerWR")),
	LatestPosts: loadable(() => import("./RebrandBlog/LatestPosts")),
	FeaturedPosts: loadable(() => import("./RebrandBlog/FeaturedPosts")),
	AutomatedMentorCards: loadable(() => import("./AutomatedMentorCards")),
	PortfolioShowcase,
	CenteredContent,
	CurriculumWR,
	SecondaryNavigationWR,
	PricingWR,
	RedesignFAQ,
	MentorCardList,
	SimplifiedList,
	MediaWithText,
	AlternateSideContentModule,
	LeadFormWR,
	ApplicationFormWR,
	BoldText,
	HeroBannerWR,
	AlumniBar,
	FormWrapper,
	BragBar,
	ModalWithForm,
	HypeCard,
	ComparisonTable,
	Testimonial,
	OverlappingCard,
	FeatureCards,
	ImportantDateCard,
	ProgramInfoPanel,
	PageNotFound,
	StatsWR,
	ReviewsModule,
};

export const ComponentTransform = {
	GeneralText: GeneralTextTransform,
	Video: videoTransform,
	MentorList: mentorListTransform,
	GeneralTextWithImage: GeneralTextWithImageTransform,
	UpcomingPrograms: UpcomingProgramsTransform,
	ProgramDetailsList: ProgramDetailsListTransform,
	ProgramDetailsCard: ProgramDetailsCardTransform,
	ProgramList: ProgramListTransform,
	Accordion: AccordionTransform,
	ApplicationForm: ApplicationFormTransform,
	LeadForm: LeadFormTransform,
	ContactUs: ContactUsTransform,
	ThankYouHeader: ThankYouHeaderTransform,
	BlogList: BlogListTransform,
	BlogImage: BlogImageTransform,
	BlogCategories: BlogCategoriesTransform,
	BlogBreadCrumbs: BlogBreadCrumbsTransform,
	BlogContent: BlogContentTransform,
	BlogVideo: BlogVideoTransform,
	BlogAuthorInfo: BlogAuthorInfoTransform,
	BlogImageBanner: BlogImageBannerTransform,
	AddressWithLogo: AddressWithLogoTransform,
	PoweredBy: PoweredByTransform,
	Image: ImageTransform,
	LinksList: LinksListTransform,
	SocialLinks: SocialLinksTransform,
	RichText: RichTextTransform,
	ProgramSchedule: ProgramScheduleTransform,
	ImageBanner: ImageBannerTransform,
	StudentTestimonial: StudentTestimonialTransform,
	ProgramListV2: ProgramListV2Transform,
	StudentProject: StudentProjectTransform,
	HeaderComponent: HeaderComponentTransfrom,
	Tuition: TuitionTransform,
	CTAButton: CTAButtonTransform,
	PortfolioShowcase: PortfolioShowcaseTransform,
	CenteredContent: CenteredContentTransform,
	CurriculumWR: CurriculumWRTransform,
	SecondaryNavigationWR: SecondaryNavigationWRTransform,
	PricingWR: PricingWRTransform,
	UpcomingProgramsWR: UpcomingProgramsWRTransform,
	TuitionWR: TuitionWRTransform,
	RedesignFAQ: RedesignFAQTransform,
	MentorCardList: MentorCardListTransform,
	SimplifiedList: SimplifiedListTransform,
	MediaWithText: MediaWithTextTransform,
	AlternateSideContentModule: AlternateSideContentModuleTransform,
	LeadFormWR: LeadFormWRTransform,
	ApplicationFormWR: ApplicationFormWRTransform,
	BoldText: BoldTextTransform,
	HeroBannerWR: HeroBannerWRTransform,
	AlumniBar: AlumniBarTransform,
	BlogCategoriesWR: BlogCategoriesWRTransform,
	BlogContentWR: BlogContentWRTransform,
	BlogBannerWR: BlogBannerWRTransform,
	LatestPosts: LatestPostsTransform,
	FeaturedPosts: FeaturedPostsTransform,
	FormWrapper: FormWrapperTransform,
	AutomatedMentorCards: AutomatedMentorCardsTransform,
	BragBar: BragBarTransform,
	ModalWithForm: ModalWithFormTransform,
	HypeCard: HypeCardTransform,
	ComparisonTable: ComparisonTableTransform,
	Testimonial: TestimonialTransform,
	OverlappingCard: OverlappingCardTransform,
	FeatureCards: FeatureCardsTransform,
	ImportantDateCard: ImportantDateCardTransform,
	ProgramInfoPanel: ProgramInfoPanelTransform,
	PageNotFound: PageNotFoundTransform,
	StatsWR: StatsWRTransform,
	ReviewsModule: ReviewsModuleTransform,
};

export default Components;
